import { OverallRatingBlock, OverallRatingBlockProps } from 'common/components/overall-rating-block';
import { getReviewsRatingTotal } from 'features/reviews/selectors';
import { connect } from 'react-redux';
import { RootReducer } from 'store/root-reducer';

export const mapStoreToProps = (store: RootReducer): OverallRatingBlockProps => {
  const totalRatingMeta = getReviewsRatingTotal(store);

  return {
    numberOfRatings: totalRatingMeta?.count ?? -1,
    ratingValue: totalRatingMeta?.score ?? -1,
  };
};

export const PdpOveralRating = connect(mapStoreToProps, null, (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...ownProps,
}))(OverallRatingBlock);
